/**
 * Landing Page - Neutral home screen for root DNS
 */

export function LandingPage() {
  return (
    <div className="landing-page">
      <div className="landing-content">
        <div className="landing-hero">
          <div className="landing-logo">
            <img src="/images/mainstay.svg" alt="Mainstay" className="logo-image" />
            <h1>Mainstay</h1>
          </div>
          <p className="landing-subtitle">Property Visit Form System</p>
        </div>

        <div className="landing-info">
          <div className="info-card">
            <h2>📧 Need Access?</h2>
            <p>
              Property visit forms are accessed via secure link sent to authorized agents. If you
              need to complete a property visit form, please check your email for the secure link.
            </p>
          </div>

          <div className="info-card">
            <h2>❓ Questions?</h2>
            <p>
              For questions about the property visit process or if you need a new link, please call
              or text <strong>1-469-949-3347</strong>.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
